/* jQuery */
import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import classnames from 'classnames'

export default class Recaptcha extends React.Component {
  constructor() {
    super()
  }

  componentDidMount() {
    try {
      const wrapper = this.refs.wrapper
      this.refs.wrapper.addEventListener('load', (e) => {
        e.target.tabIndex = this.props.tabindex
        wrapper
          .querySelector('textarea')
          .setAttribute('required', true)
      }, true)
    } catch(err) { console.error(err) }
  }

  reset() {
    this.refs.recaptcha.reset()
  }

  render() {
    /* eslint-disable no-unused-vars */
    const { groupClass, tabindex, ...rest } = this.props
    /* eslint-enable no-unused-vars */
    return (
      <div className={classnames('form__group', groupClass)} ref="wrapper">
        <ReCAPTCHA {...rest} ref="recaptcha"/>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/components/common/Recaptcha.jsx
 **/